export default "__VITE_ASSET__3jihE_Ia__";